import { render, staticRenderFns } from "./mdl-concludi.vue?vue&type=template&id=53e8a7fa&"
import script from "./mdl-concludi.vue?vue&type=script&lang=js&"
export * from "./mdl-concludi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports